import { AppUtil } from 'kuaidong-lib'
import { IGiftOrderDetail, IGiftOrderInfo, ITeacherAddressInfo, ITeacherAddressInfoForm } from 'kuaidong-model'

export class AGiftOrder {
  public static async list(): Promise<IGiftOrderInfo[]> {
    return AppUtil.httpGET('/web/gift_order/gift_order_list')
  }

  public static async orderDetail(gift_order_id: string): Promise<IGiftOrderDetail> {
    return AppUtil.httpGET('/web/gift_order/gift_order_detail', {
      gift_order_id,
    })
  }

  public static async teacherAddressList(): Promise<ITeacherAddressInfo[]> {
    return AppUtil.httpGET('/teacher/teacher_address_list')
  }

  public static async getAddressById(addressId: string): Promise<ITeacherAddressInfo | null> {
    const addresses = await this.teacherAddressList()
    return addresses.find((x) => x.address_id === addressId) || null
  }

  public static async getCandidateTeacherAddress(): Promise<ITeacherAddressInfo | null> {
    // 有默认选择默认，否则拿第一个, 没有返回null
    const addresses = await this.teacherAddressList()
    if (addresses.length == 0) {
      return null
    }
    const defaultAddress = addresses.find((x) => x.default)
    return defaultAddress ? defaultAddress : addresses[0]
  }

  public static async addTeacherAddress(form: ITeacherAddressInfoForm): Promise<any> {
    return AppUtil.httpPOST('/teacher/teacher_address_list', form)
  }

  public static async delTeacherAddress(address_id: string): Promise<any> {
    return AppUtil.httpDelete('/teacher/teacher_address_list', {
      address_id,
    })
  }

  public static async updateTeacherAddress(form: ITeacherAddressInfo): Promise<any> {
    return AppUtil.httpPUT('/teacher/teacher_address_list', form)
  }

  public static async confirmGiftOrderDetail(gift_order_id: string) {
    return AppUtil.httpPUT('/web/gift_order/gift_order_detail', {
      gift_order_id,
    })
  }

  public static async updateGiftOrderAddress(gift_order_id: string, address_id: string) {
    return AppUtil.httpPOST('/web/gift_order/gift_order_detail', {
      gift_order_id,
      address_id,
    })
  }
}
